import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Typography,
  Box,
  Card,
  CardContent,
  Chip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import {
  COLUMN_ACCOM_MINI,
  COLUMN_ITINERRARY_MINI,
} from "../utils/constDispatch";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import ListRoundedIcon from "@mui/icons-material/ListRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import RemoveCircleOutlineRoundedIcon from "@mui/icons-material/RemoveCircleOutlineRounded";
import {
  API_create_vendor,
  API_delete_vendors_id,
  API_edit_vendor,
  API_get_vendor,
  API_get_vendor_att,
} from "../utils/http";

import _ from "lodash";
import { render_number, render_number_onchange } from "../utils/tool";

const sectionCard = {
  padding: "12px 16px",
  marginBottom: "16px",
  borderRadius: "10px",
  backgroundColor: "#fff",
  boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
  border: "1px solid #E0E0E0",
};

const pillBtn = {
  borderRadius: "20px",
  textTransform: "none",
  fontWeight: 500,
  fontSize: 13,
};

const dataGridSx = {
  "& .MuiDataGrid-root": {
    border: "1px solid #E0E0E0",
    borderRadius: "10px",
    overflow: "hidden",
    fontSize: 13,
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "#F5F7FA",
    fontSize: 13,
    fontWeight: 600,
    color: "#555",
    borderBottom: "1px solid #E0E0E0",
  },
  "& .MuiDataGrid-row": {
    "&:hover": { backgroundColor: "#F8FBFF" },
    "&.Mui-selected": {
      backgroundColor: "#EBF4FF",
      "&:hover": { backgroundColor: "#DDEEFF" },
    },
  },
  "& .MuiDataGrid-cell": {
    borderBottom: "1px solid #F0F0F0",
  },
  "& .MuiDataGrid-footerContainer": {
    borderTop: "1px solid #E0E0E0",
    backgroundColor: "#FAFAFA",
  },
};

export default function VendorService(props) {
  let props_activ = props.activ;
  let props_type_activ = true;
  if (props.vendorType == "hotel" || props.vendorType == "cruise") {
    props_activ = props.accom;
    props_type_activ = false;
  }

  const [id_service_click, set_id_service_click] = useState(null);
  const [id_service_code, set_id_service_code] = useState(null);
  const [id_service_price, set_id_service_price] = useState(null);

  const [id_service_price_for_cus, set_id_service_price_for_cus] =
    useState(null);
  const [pickup_place, set_pickup_place] = useState(null);
  const [dropoff_place, set_dropoff_place] = useState(null);

  const [new_code, set_new_code] = useState(null);
  const [new_price, set_new_price] = useState(null);

  const [new_price_for_cus, set_new_price_for_cus] = useState(null);
  const [new_pickup_place, set_new_pickup_place] = useState(null);
  const [new_dropoff_place, set_new_dropoff_place] = useState(null);

  const [search_text, set_search_text] = useState("");
  const [rowSelection_not_contain, set_rowSelection_not_contain] = useState([]);
  const [rowSelection_contain, set_rowSelection_contain] = useState([]);

  const [data_filter, set_data_filter] = useState([]);
  const [list_att, set_list_att] = useState([]);
  const [list_or_add, set_list_or_add] = useState("list");

  const handle_search = (search_text) => {
    if (search_text.replace(/\W/g, "").toLocaleLowerCase() == "") {
      set_data_filter(props_activ);
    } else {
      let data_tmp = props_activ.filter((x) => {
        let str = "";
        if (props_type_activ) {
          str = x.label + x.activities;
        } else {
          str = x.code;
        }

        str = str.replace(/\W/g, "").toLocaleLowerCase();
        let str_search = search_text.replace(/\W/g, "").toLocaleLowerCase();
        return str.includes(str_search);
      });

      set_data_filter(data_tmp);
    }
  };

  function clickService(item) {
    set_id_service_click(item._id);
    set_id_service_code(item.code);

    set_id_service_price(render_number(item.price));
    set_id_service_price_for_cus(render_number(item.price_for_customer));

    set_pickup_place(item.pickup_place == null ? "" : item.pickup_place);
    set_dropoff_place(item.dropoff_place == null ? "" : item.dropoff_place);

    set_rowSelection_not_contain([]);

    set_data_filter(props_activ);

    let list_att_new = _.filter(props_activ, (v) =>
      _.includes(item.attach_acti, v._id)
    );

    set_list_att(list_att_new);
  }

  function deleteService() {
    API_delete_vendors_id(id_service_click, (data) => {
      if (data.success) {
        props.get_data_vendor_att();
      }
    });
  }

  function saveService() {
    let list_att_new = [];

    list_att.forEach((element) => {
      list_att_new.push(element._id);
    });

    API_edit_vendor(
      id_service_click,
      {
        code: id_service_code,
        price: Number(id_service_price.replaceAll(/,/g, "")),
        price_currency: "VND",
        price_for_customer: Number(
          id_service_price_for_cus.replaceAll(/,/g, "")
        ),
        price_for_customer_currency: "VND",
        attach_acti: list_att_new,
        pickup_place: pickup_place,
        dropoff_place: dropoff_place,
      },
      (data) => {
        if (data.success) {
          props.get_data_vendor_att();
        }
      }
    );
  }

  function AddService() {
    console.log(props.vendorGroupID);
    API_create_vendor(
      {
        code: new_code,
        price: Number(new_price.replaceAll(/,/g, "")),
        price_currency: "VND",
        price_for_customer: Number(new_price_for_cus.replaceAll(/,/g, "")),
        price_for_customer_currency: "VND",
        attach_acti: [],
        vendorgroup_id: props.vendorGroupID,
        pickup_place: new_pickup_place,
        dropoff_place: new_dropoff_place,
      },
      (data) => {
        if (data.success) {
          props.get_data_vendor_att();
          set_list_or_add("list");
        }
      }
    );
  }

  function AddServiceBtn(arr_add) {
    let x = list_att.concat(
      _.filter(props_activ, (v) => _.includes(arr_add, v._id))
    );

    let x_unique = _.uniqBy(x, function (e) {
      return e._id;
    });

    set_list_att(x_unique);
  }

  function RemoveService(id) {
    let x = [];
    list_att.forEach((e) => {
      if (e._id != id) {
        x.push(e);
      }
    });
    set_list_att(x);
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      {/* Toggle buttons */}
      <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
        <Button
          size="small"
          variant={list_or_add === "add" ? "contained" : "outlined"}
          startIcon={<AddRoundedIcon sx={{ fontSize: 16 }} />}
          sx={pillBtn}
          onClick={() => set_list_or_add("add")}
        >
          Add Services
        </Button>
        <Button
          size="small"
          variant={list_or_add === "list" ? "contained" : "outlined"}
          startIcon={<ListRoundedIcon sx={{ fontSize: 16 }} />}
          sx={pillBtn}
          onClick={() => set_list_or_add("list")}
        >
          List of Services
        </Button>
      </Box>

      {/* Notes card */}
      <Box sx={{ ...sectionCard, padding: "12px 16px" }}>
        <Typography sx={{ fontWeight: 600, fontSize: 13, mb: 0.5 }}>
          Transportation Code Reference
        </Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
          {[
            { code: "DON", desc: "đón từ KS hôm trước → dropoff_place" },
            { code: "TIEN", desc: "tiễn từ KS hôm nay → pickup_place" },
            // { code: "GENERAL", desc: "đón từ KS hôm trước → KS hôm nay" },
          ].map((item) => (
            <Box
              key={item.code}
              sx={{
                padding: "4px 12px",
                borderRadius: "8px",
                backgroundColor: "#F5F7FA",
                fontSize: 12,
                color: "#555",
                display: "flex",
                alignItems: "center",
                gap: 0.5,
              }}
            >
              <span style={{ fontFamily: "monospace", fontWeight: 600, color: "#1565C0" }}>
                {item.code}
              </span>
              <span style={{ color: "#999" }}>—</span>
              {item.desc}
            </Box>
          ))}
        </Box>
      </Box>

      {list_or_add === "add" ? (
        <Box sx={sectionCard}>
          <Typography sx={{ fontWeight: 600, fontSize: 15, mb: 1.5 }}>
            New Service
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <TextField
              size="small"
              label="Code"
              value={new_code}
              onChange={(e) => set_new_code(e.target.value)}
              fullWidth
            />
            <TextField
              size="small"
              label="Double"
              value={new_price}
              onChange={(e) => set_new_price(render_number_onchange(e.target.value))}
              fullWidth
            />
            <TextField
              size="small"
              label="Single"
              value={new_price_for_cus}
              onChange={(e) => set_new_price_for_cus(render_number_onchange(e.target.value))}
              fullWidth
            />
            <TextField
              size="small"
              label="Pickup place"
              value={new_pickup_place}
              onChange={(e) => set_new_pickup_place(e.target.value)}
              fullWidth
            />
            <TextField
              size="small"
              label="Dropoff place"
              value={new_dropoff_place}
              onChange={(e) => set_new_dropoff_place(e.target.value)}
              fullWidth
            />
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 0.5 }}>
              <Button
                size="small"
                variant="contained"
                sx={pillBtn}
                onClick={() => AddService()}
              >
                Confirm
              </Button>
            </Box>
          </Box>
        </Box>
      ) : null}
      {list_or_add === "list" ? (
        <Box>
          {/* Action bar */}
          <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
            <Button
              size="small"
              disabled={id_service_click == null}
              variant="outlined"
              color="error"
              startIcon={<DeleteRoundedIcon sx={{ fontSize: 16 }} />}
              sx={pillBtn}
              onClick={() => deleteService()}
            >
              Delete
            </Button>
            <Button
              size="small"
              disabled={id_service_click == null}
              variant="contained"
              startIcon={<SaveRoundedIcon sx={{ fontSize: 16 }} />}
              sx={pillBtn}
              onClick={() => saveService()}
            >
              Save
            </Button>
          </Box>

          {/* Service cards as horizontal wrap */}
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, mb: 2 }}>
            {props.data.map((item) => (
              <Card
                key={item._id}
                onClick={() => clickService(item)}
                elevation={0}
                sx={{
                  borderRadius: "10px",
                  border: id_service_click === item._id
                    ? "1px solid #42A5F5"
                    : "1px solid #E0E0E0",
                  borderLeft: id_service_click === item._id
                    ? "3px solid #1976D2"
                    : "3px solid transparent",
                  backgroundColor: id_service_click === item._id ? "#F0F7FF" : "#fff",
                  boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
                  cursor: "pointer",
                  transition: "all 0.15s",
                  width: 260,
                  "&:hover": {
                    boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
                  },
                }}
              >
                <CardContent sx={{ p: "10px 14px", "&:last-child": { pb: "10px" } }}>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 0.5 }}>
                    <Typography sx={{ fontWeight: 600, fontSize: 13, color: "#1565C0" }}>
                      {item.code}
                    </Typography>
                    <Chip
                      label={`${item.attach_acti.length} linked`}
                      size="small"
                      sx={{ fontSize: 10, fontWeight: 500, backgroundColor: "#EBF4FF", color: "#1565C0", height: 20 }}
                    />
                  </Box>
                  <Box sx={{ display: "flex", gap: 1.5 }}>
                    <Typography sx={{ fontSize: 12, color: "#333" }}>
                      <span style={{ color: "#999", fontSize: 10, fontWeight: 600, textTransform: "uppercase" }}>Dbl </span>
                      {render_number(item.price)} {item.price_currency}
                    </Typography>
                    <Typography sx={{ fontSize: 12, color: "#333" }}>
                      <span style={{ color: "#999", fontSize: 10, fontWeight: 600, textTransform: "uppercase" }}>Sgl </span>
                      {render_number(item.price_for_customer)} {item.price_for_customer_currency}
                    </Typography>
                  </Box>
                  {(item.pickup_place || item.dropoff_place) && (
                    <Box sx={{ display: "flex", gap: 1.5, mt: 0.3 }}>
                      {item.pickup_place && (
                        <Typography sx={{ fontSize: 11, color: "#999" }}>
                          PU: {item.pickup_place}
                        </Typography>
                      )}
                      {item.dropoff_place && (
                        <Typography sx={{ fontSize: 11, color: "#999" }}>
                          DO: {item.dropoff_place}
                        </Typography>
                      )}
                    </Box>
                  )}
                </CardContent>
              </Card>
            ))}
          </Box>

          {/* Edit form - compact inline */}
          {id_service_click == null ? null : (
            <Box sx={{ ...sectionCard, padding: "12px 16px" }}>
              <Typography sx={{ fontWeight: 600, fontSize: 13, mb: 1.5 }}>
                Edit Service
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                {/* Row 1: Code + Double/currency + Single/currency */}
                <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                  <TextField
                    size="small"
                    label="Code"
                    value={id_service_code}
                    onChange={(e) => set_id_service_code(e.target.value)}
                    sx={{ flex: 2 }}
                  />
                  <TextField
                    size="small"
                    label="Double"
                    value={id_service_price}
                    onChange={(e) => set_id_service_price(render_number_onchange(e.target.value))}
                    sx={{ flex: 1 }}
                  />
                  <TextField
                    size="small"
                    label="Single"
                    value={id_service_price_for_cus}
                    onChange={(e) => set_id_service_price_for_cus(render_number_onchange(e.target.value))}
                    sx={{ flex: 1 }}
                  />
                </Box>
                {/* Row 2: Pickup + Dropoff */}
                <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                  <TextField
                    size="small"
                    label="Pickup place"
                    value={pickup_place}
                    onChange={(e) => set_pickup_place(e.target.value)}
                    sx={{ flex: 1 }}
                  />
                  <TextField
                    size="small"
                    label="Dropoff place"
                    value={dropoff_place}
                    onChange={(e) => set_dropoff_place(e.target.value)}
                    sx={{ flex: 1 }}
                  />
                </Box>
              </Box>
            </Box>
          )}

          {id_service_click == null ? null : (
            <Box sx={{ display: "flex", flexDirection: "row", gap: 2, mt: 2 }}>
              {/* List contained */}
              <Box sx={{ flex: 1, ...dataGridSx }}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
                  <Typography sx={{ fontWeight: 600, fontSize: 14 }}>
                    Linked Items
                    <Chip
                      label={list_att.length}
                      size="small"
                      sx={{ ml: 1, fontSize: 11, fontWeight: 600, backgroundColor: "#EBF4FF", color: "#1565C0", height: 20 }}
                    />
                  </Typography>
                  <Button
                    size="small"
                    variant="outlined"
                    color="error"
                    startIcon={<RemoveCircleOutlineRoundedIcon sx={{ fontSize: 14 }} />}
                    sx={pillBtn}
                    onClick={() => RemoveService(rowSelection_contain)}
                  >
                    Remove
                  </Button>
                </Box>
                <DataGrid
                  density="compact"
                  getRowId={(item) => item._id}
                  rows={list_att}
                  columns={props_type_activ ? COLUMN_ITINERRARY_MINI : COLUMN_ACCOM_MINI}
                  initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
                  pageSizeOptions={[5, 10, 20, 50]}
                  rowSelectionModel={rowSelection_contain}
                  onRowSelectionModelChange={(e) => set_rowSelection_contain(e)}
                  keepNonExistentRowsSelected
                />
              </Box>

              {/* List not contained */}
              <Box sx={{ flex: 1, ...dataGridSx }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                  <Typography sx={{ fontWeight: 600, fontSize: 14 }}>
                    Available
                  </Typography>
                  <Button
                    size="small"
                    variant="contained"
                    startIcon={<AddRoundedIcon sx={{ fontSize: 14 }} />}
                    sx={pillBtn}
                    onClick={() => AddServiceBtn(rowSelection_not_contain)}
                  >
                    Add
                  </Button>
                  <TextField
                    size="small"
                    placeholder="Search..."
                    value={search_text}
                    onChange={(e) => {
                      if (e.target.value === "") handle_search("");
                      set_search_text(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handle_search(e.target.value);
                    }}
                    sx={{ flex: 1 }}
                  />
                </Box>
                <DataGrid
                  density="compact"
                  getRowId={(item) => item._id}
                  rows={id_service_click == null ? [] : data_filter}
                  columns={props_type_activ ? COLUMN_ITINERRARY_MINI : COLUMN_ACCOM_MINI}
                  initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
                  pageSizeOptions={[5, 10, 20, 50]}
                  rowSelectionModel={rowSelection_not_contain}
                  onRowSelectionModelChange={(e) => set_rowSelection_not_contain(e)}
                  keepNonExistentRowsSelected
                  checkboxSelection
                />
              </Box>
            </Box>
          )}
        </Box>
      ) : null}
    </Box>
  );
}
